import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { InputField } from 'components/common/FormElements/Input'
import Button from 'components/common/Button/Button'
import model from './viewModel'
import { normalizePhoneNumber } from 'helpers/phone-number'

const ProvidePhoneNumberForm = ({
  handleSubmit,
  isProvidePhoneNumberFormSubmitting,
  onCancel,
  submitProvidePhoneNumberForm
}) =>
  <form noValidate onSubmit={ handleSubmit }>
    <InputField { ...model.primaryPhone } normalize={ normalizePhoneNumber } full="mobile" static />
    <Buttons>
      <Button
        data-at-update-button
        full="mobile"
        stacked="mobile"
        onClick={ submitProvidePhoneNumberForm }>Update</Button>
      <Button
        data-at-cancel-button
        full="mobile"
        link
        bolder
        stacked="mobile"
        onClick={ onCancel }>Cancel</Button>
    </Buttons>
  </form>

ProvidePhoneNumberForm.propTypes = {
  handleSubmit: PropTypes.func,
  hideProvidedNumberPhoneModal: PropTypes.func,
  isProvidePhoneNumberFormSubmitting: PropTypes.bool,
  onCancel: PropTypes.func,
  submitProvidePhoneNumberForm: PropTypes.func,
  submitting: PropTypes.bool
}

export default ProvidePhoneNumberForm

const Buttons = styled.div`
  margin-top: 22px;
`
